module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bubbleBath@3x_fb3347.png";